// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EqBehoiL60usTp4g {
  max-width: 1315px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.eDzJmS83yUM7I_b4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.t02RuAJHAtMPsWbz {
  width: 300px;
  padding: 12px 10px;
  border-radius: 16px;
}

.ScMM79oFMI47oNfe {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 20px;
}

.NeprssEXbLAhxVc_ {
  display: flex;
  margin-top: 28px;
  gap: 12px;
}

.Kyz5MQQLgqUJ_2E_,
.aXYOWP8LE6wiVNwN {
  margin-bottom: 5px;
  padding: 8px 14px;
  font-size: 18px;
  font-weight: 300;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  background-color: #fff;
  color: #7b7b7b;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.Kyz5MQQLgqUJ_2E_:hover,
.aXYOWP8LE6wiVNwN:hover {
  background-color: #e1e7ed;
}

.bUqCUqK_sCQOYVgF {
  display: flex;
  align-items: center;
}

.YQZXWKkYsbUbr2ME {
  margin-right: 10px;
}

.Bgn0L4AEMEkf0RyZ {
  color: #000000;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.Bgn0L4AEMEkf0RyZ i {
  font-size: 16px;
  background-color: #4d87be;
  color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  margin-right: 12px;
}

.Bgn0L4AEMEkf0RyZ:hover i {
  background-color: #20336c;
}

.Bgn0L4AEMEkf0RyZ:hover .pBx1O2u1g83OmIl7 {
  text-decoration: underline;
}

.Bgn0L4AEMEkf0RyZ .pBx1O2u1g83OmIl7 {
  text-decoration: none;
}

.Rv38fSdk5c2MeUO3 {
  border-radius: 16px;
  background-color: #fff;
  padding: 10px;
}

.Rv38fSdk5c2MeUO3 .p-accordion {
  border: none;
  box-shadow: none;
}

.Rv38fSdk5c2MeUO3 .p-accordion .p-accordion-tab {
  border: none;
}

.Rv38fSdk5c2MeUO3 .p-accordion-header-link {
  background-color: #fff;
  border: none;
}

.Rv38fSdk5c2MeUO3 .p-accordion-content {
  background-color: #fff;
  border: none;
}

.oRsJzZQ1KMkQMA3Q {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.oRsJzZQ1KMkQMA3Q span {
  font-size: 20px;
  font-weight: 500;
}

.ycu1LDWik4VDuu7Z .p-orderlist-controls {
  display: none;
}

/*.orderListItem {*/
/*	margin: 0;*/
/*	padding: 0;*/
/*	height: 80px;*/
/*}*/

.g2ed92cNMFUNe4rT {
  margin: 0 30px 52px;
  width: calc(100% - 60px);
}

.g2ed92cNMFUNe4rT .p-dropdown {
  width: 100%;
  height: 66px;
  border-radius: 24px;
}

.g2ed92cNMFUNe4rT .p-dropdown-label {
  display: block;
  padding: 17px 32px 24px;
  font-size: 21px;
  font-family: "Roboto";
}

.JrwjgJX2c8MgsJ6H {
  border-radius: 24px;
  border: 1px solid #a4a4a4;
  overflow: hidden;
  padding: 16px 34px;
}

.JrwjgJX2c8MgsJ6H .p-dropdown-items-wrapper {
  max-height: 400px !important;
}

.JrwjgJX2c8MgsJ6H .p-dropdown-items li {
  height: 88px;
  border-radius: 6px;
  margin: 4px 0px;
  padding: 4px;
}

.JrwjgJX2c8MgsJ6H .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  border: 2px solid transparent;
}

.JrwjgJX2c8MgsJ6H .p-dropdown-item.p-highlight {
  color: #ffffff;
  background-color: #20336c;
}

.z9mX0yBXQVwuqqYg .p-orderlist-header {
  background-color: #f2e1bc;
  border-radius: 0 0 0 0;
  border: none;
}

.z9mX0yBXQVwuqqYg .p-orderlist-list {
  border-radius: 0 0 0 0;
  border: none;
  background-color: #faf9f8;
}

.z9mX0yBXQVwuqqYg .p-orderlist-item:hover {
  background-color: #f5f4f3;
}

.IZIJKEQ5ooE38He2 {
  height: 100%;
  font-size: 18px;
  font-weight: 400;
}

.QAkUSnOFbe4gGLJY,
.IZIJKEQ5ooE38He2 {
  display: flex;
}

.QAkUSnOFbe4gGLJY > div,
.IZIJKEQ5ooE38He2 > div {
  width: 25%;
  align-self: center;
}

.QAkUSnOFbe4gGLJY > .IpM8k09LUIObbxHz,
.IZIJKEQ5ooE38He2 > .IpM8k09LUIObbxHz {
  width: 95px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
}

.DI7llyzTVHApKbHu {
  position: absolute;
  color: #fff;
  width: 67px;
  height: 67px;
  display: none;
  border-radius: 6px;
}

.DI7llyzTVHApKbHu:hover {
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(0.893727px);
  display: flex;
}

.DI7llyzTVHApKbHu:hover::before {
  display: flex;
}

.DI7llyzTVHApKbHu::before {
  top: 37%;
  left: 37%;
  font-size: 18px;
  position: absolute;
  display: none;
}

.K4bg2eI5Ps_nb417 {
  width: 67px;
  height: 67px;
  overflow: hidden;
  border-radius: 6px;
}

.NZj70HNlZBozZQCG {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.Kyz5MQQLgqUJ_2E_ {
  margin-right: 5px;
}

.Kyz5MQQLgqUJ_2E_,
.aXYOWP8LE6wiVNwN {
  margin-bottom: 5px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgb(222, 226, 230);
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
}

.Nx9os3kIkdo7Kjbe {
  margin-bottom: 15px;
}

.BU2Dd3sNzkrxit8n {
  display: flex;
  gap: 20px;
}

.LQ9jxmHt4kE5IbFW {
  width: 114px;
  height: 67px;
}

.LQ9jxmHt4kE5IbFW:hover {
  background-color: #e1e7ed;
  border-radius: 6px;
}

.efrA6tVm0jcxhmAk {
  color: #818b93;
}

.efrA6tVm0jcxhmAk:hover {
  background-color: #dfdfdf;
}

.Su9HbssAiNB2K6pn {
  color: #c88900;
}

.Su9HbssAiNB2K6pn:hover {
  background-color: #f2e1bc;
  color: #9a6a00;
}

.T5IW7Dnm9IphZnJt {
  color: #4d87be;
}

.T5IW7Dnm9IphZnJt:hover {
  background-color: #e1e7ed;
  color: #20336c;
}

.l4e1U4fBAY2OtonJ {
  color: #dd0000;
}

.l4e1U4fBAY2OtonJ:hover {
  background-color: #ffcaca;
  color: #721010;
}

.kh_Uh3ZrksE6sDaz {
  display: flex;
  gap: 8px;
  margin-left: 10px;
}

.jwXN6S86nVghNM9L {
  color: #4d87be;
  width: 75px;
  height: 67px;
  border-radius: 6px;
}

.jwXN6S86nVghNM9L:hover {
  background-color: #e1e7ed;
  color: #20336c;
}

.oZCnxg5ygQnaJsZk {
  color: #dd0000;
  width: 75px;
  height: 67px;
  border-radius: 6px;
}

.oZCnxg5ygQnaJsZk:hover {
  background-color: #ffcaca;
  color: #721010;
}

.pG1fG2WihMsrGsfh {
  width: 674px !important;
  height: fit-content;
  background-color: #f3f5f7;
  border-radius: 16px !important;
}

.pG1fG2WihMsrGsfh .p-dialog {
  border-radius: 16px !important;
}

.pG1fG2WihMsrGsfh .p-dialog-footer {
  border-bottom-right-radius: 16px !important;
  border-bottom-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.pG1fG2WihMsrGsfh .p-dialog-header {
  border-top-right-radius: 16px !important;
  border-top-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa {
  width: 541px !important;
  height: 354px !important;
  background-color: #f3f5f7;
  border-radius: 25px !important;
}

.By_14zkV4XUVNJKa .p-dialog {
  border-radius: 25px !important;
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa .p-dialog-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.By_14zkV4XUVNJKa .RaqWt5qIR14DkLs6 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.QSHyt7sOmMwSZ6Kf {
  width: 100%;
  background-color: #56be4d;
  border-radius: 16px;
  padding: 18px 0px;
  color: #ffffff;
  border: none;
  font-size: 20px;
  font-weight: 600;
}

.QSHyt7sOmMwSZ6Kf:hover {
  background-color: #185625;
}

.d8TTigY5xWktckql {
  background-color: #e1e7ed;
  border-radius: 16px;
  overflow: hidden;
}

.d8TTigY5xWktckql .p-button {
  background-color: transparent;
  border: none;
  font-size: 20px;
  padding: 15px 0px;
}

.d8TTigY5xWktckql .p-highlight {
  background-color: #4d87be;
  border-radius: 16px;
}

.NBV7bgeoBgmliiyv {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.k2GbHgRW4rZk_JIs input {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.aqtEWWvRQtoudWLx {
  background-color: #ffffff;
  border-radius: 16px;
  height: 91px;
  padding: 14px 20px;
  font-size: 18px;
  resize: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.lqqhiUYbbL0eaHSe {
  width: 100%;
  background-color: #dd0000;
  border-radius: 16px;
  padding: 18px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.lqqhiUYbbL0eaHSe:hover {
  background-color: #721010;
}

.RJyi_a8SMoa_MB_w {
  width: 100%;
  background-color: #f3f5f7;
  border-radius: 16px;
  padding: 10px 20px;
  color: #4d87be;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.RJyi_a8SMoa_MB_w:hover {
  color: #305375;
}

.SNjLIZnuEILBidDk {
  width: 604px;
  height: 475px;
  background-color: #f3f5f7;
  border-radius: 16px !important;
}

.SNjLIZnuEILBidDk .p-dialog-content {
  max-height: 300px !important;
  padding: 0 !important;
  background-color: #f3f5f7;
}

.SNjLIZnuEILBidDk .p-dialog {
  border-radius: 16px !important;
  background-color: #f3f5f7;
}

.SNjLIZnuEILBidDk .p-dialog-header {
  border-top-right-radius: 16px !important;
  border-top-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.SNjLIZnuEILBidDk .p-dialog-footer {
  padding: 1.5rem !important;
  border-bottom-right-radius: 16px !important;
  border-bottom-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.v9cdw2UvuTcYOa0t {
  display: inline-block;
}

.SQBO1xc2tO8EWgJF {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.GkeIc9cHaMrjJczz {
  width: 250px;
  height: 250px;
  border-radius: 25px;
  overflow: hidden;
}

.GkeIc9cHaMrjJczz .CmxWy2ztikMeuGQt {
  height: 100%;
  width: 100%;
}

.SHjY2wLeVtMfzeAq {
  width: 100%;
}

.SHjY2wLeVtMfzeAq > span {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #4d87be;
  border-radius: 16px;
  padding: 14px 0;
  font-size: 18px;
  font-weight: 600;
}

.SHjY2wLeVtMfzeAq > span:hover {
  background-color: #20336c;
}

.SHjY2wLeVtMfzeAq > span > span {
  width: fit-content;
  flex-grow: 0;
}

.pG1fG2WihMsrGsfh .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.By_14zkV4XUVNJKa .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.SNjLIZnuEILBidDk .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.pG1fG2WihMsrGsfh .p-dialog-content {
  background-color: #f3f5f7;
}

.SNjLIZnuEILBidDk .p-dialog-content {
  background-color: #f3f5f7;
}

.By_14zkV4XUVNJKa .p-dialog-content {
  background-color: #f3f5f7;
}

.pG1fG2WihMsrGsfh .field label {
  font-size: 20px !important;
  font-weight: 400 !important;
}

.e7fzFJef582wNzou {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.NFn9akhDRXA15dAI {
  background: #ffffff;
  padding: 8px;
  border-radius: 8px;
  min-height: 63px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.AFJLDsDEJU4t4ONL {
  background-size: cover;
  min-width: 56px !important;
  min-height: 56px !important;
  background-color: gray;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
}

.N0kaviNcQkcaVHnz {
  display: flex;
  flex-direction: row;
}

.N0kaviNcQkcaVHnz .mVytRCEAikVQWGzO {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.P3c52QVyrMo03tFK {
  font-weight: 500;
  color: #303030;
  font-size: 14px;
}

.tQgBQ6Ui33MGby9t {
  color: #888888;
  font-weight: 400;
  font-size: 12px;
}

.ATJvkSeaxKU_JFsx {
  display: flex;
  gap: 12px;
}

.meyIPXyliMA2xdCy {
  color: #1976d2;
  background: none;
  border: none;
}

.iJZRbXbk4qAMbMam {
  color: #d32f2f;
  background: none;
  border: none;
  font-size: 20px;
}

.meyIPXyliMA2xdCy i::before,
.iJZRbXbk4qAMbMam i::before {
  font-size: 16px;
}

.pCT9a4sDYRAjhpln {
  color: #000000;
  background-color: transparent;
  border: none;
  padding: 0;
  width: 100%;
}

.pCT9a4sDYRAjhpln i {
  margin-left: 0;
  width: 100%;
  font-size: 14px;
  background-color: #f2e1bc;
  padding: 6px;
  border-radius: 8px;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .IZIJKEQ5ooE38He2 {
    font-size: 14px;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(2) {
    width: 180px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(3) {
    width: 100px !important;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(4) {
    width: 80px !important;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(5) {
    width: 200px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(6) {
    width: 80px !important;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(7) {
    width: 120px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(2) {
    width: 180px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(3) {
    width: 100px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(4) {
    width: 80px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(5) {
    width: 200px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(6) {
    width: 80px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(7) {
    width: 120px !important;
  }
  
  .K4bg2eI5Ps_nb417 {
    width: 50px;
    height: 50px;
  }
  
  .jwXN6S86nVghNM9L,
  .oZCnxg5ygQnaJsZk {
    width: 50px;
    height: 50px;
  }
  
  .LQ9jxmHt4kE5IbFW {
    width: 50px;
    height: 50px;
  }
  
  .kh_Uh3ZrksE6sDaz {
    gap: 4px;
  }
}

@media screen and (min-width: 768px) and (max-width: 900px) {
  .IZIJKEQ5ooE38He2 > div:nth-child(2) {
    width: 150px !important;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(3) {
    width: 80px !important;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(4) {
    width: 70px !important;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(5) {
    width: 160px !important;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(6) {
    width: 70px !important;
  }
  
  .IZIJKEQ5ooE38He2 > div:nth-child(7) {
    width: 100px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(2) {
    width: 150px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(3) {
    width: 80px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(4) {
    width: 70px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(5) {
    width: 160px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(6) {
    width: 70px !important;
  }
  
  .QAkUSnOFbe4gGLJY > div:nth-child(7) {
    width: 100px !important;
  }
  
  .K4bg2eI5Ps_nb417 {
    width: 45px;
    height: 45px;
  }
  
  .jwXN6S86nVghNM9L,
  .oZCnxg5ygQnaJsZk {
    width: 45px;
    height: 45px;
  }
  
  .LQ9jxmHt4kE5IbFW {
    width: 45px;
    height: 45px;
  }
  
  .kh_Uh3ZrksE6sDaz {
    gap: 2px;
  }
}

@media screen and (max-width: 768px) {
  .By_14zkV4XUVNJKa,
  .pG1fG2WihMsrGsfh {
    width: 350px !important;
  }
  
  .pG1fG2WihMsrGsfh .field label {
    font-size: 14px !important;
  }
  
  .SNjLIZnuEILBidDk .p-dialog-title,
  .By_14zkV4XUVNJKa .p-dialog-title,
  .pG1fG2WihMsrGsfh .p-dialog-title {
    font-size: 20px !important;
    font-weight: 700 !important;
  }
  
  .By_14zkV4XUVNJKa .RaqWt5qIR14DkLs6 {
    font-size: 16px;
  }
  
  .NBV7bgeoBgmliiyv {
    font-size: 14px;
    padding: 14px 20px;
    background-color: #ffffff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
  }
  
  .QSHyt7sOmMwSZ6Kf {
    padding: 14px 0;
    font-size: 16px;
  }
  
  .lqqhiUYbbL0eaHSe {
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 16px;
  }
  
  .RJyi_a8SMoa_MB_w {
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 16px;
  }
  
  .d8TTigY5xWktckql {
    background-color: #e1e7ed;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .d8TTigY5xWktckql .p-button {
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-weight: 500;
    padding: 15px 0;
  }
  
  .d8TTigY5xWktckql .p-highlight {
    background-color: #4d87be;
    border-radius: 8px;
  }
  
  .SNjLIZnuEILBidDk {
    width: 350px;
  }
  
  .SNjLIZnuEILBidDk p {
    font-size: 14px;
    text-align: center;
  }
  
  .SHjY2wLeVtMfzeAq > span {
    font-size: 16px;
  }
}

@media screen and (max-width: 764px) {
  .oRsJzZQ1KMkQMA3Q span {
    font-size: 18px;
  }
}

@media screen and (max-width: 660px) {
  .oRsJzZQ1KMkQMA3Q span {
    font-size: 16px;
  }
}

@media screen and (max-width: 600px) {
  .eDzJmS83yUM7I_b4 {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    width: 100%;
  }
  
  .eDzJmS83yUM7I_b4 h2 {
    font-size: 20px;
    font-weight: 700;
  }
  
  .t02RuAJHAtMPsWbz {
    width: 100%;
    font-size: 14px !important;
    border-radius: 16px;
    padding: 4px 6px;
    height: 44px;
  }
  
  .t02RuAJHAtMPsWbz::placeholder {
    font-size: 14px;
  }
  
  .ScMM79oFMI47oNfe {
    flex-direction: row-reverse;
    margin-top: 16px;
    align-items: start;
    justify-content: space-between;
  }
  
  .NeprssEXbLAhxVc_ {
    margin: 0;
    gap: 0;
  }
  
  .Bgn0L4AEMEkf0RyZ {
    padding: 0;
  }
  
  .Bgn0L4AEMEkf0RyZ span {
    display: none;
  }
  
  .Bgn0L4AEMEkf0RyZ i {
    font-size: 14px;
    width: 63px;
    height: 26px;
    border-radius: 6px;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .Kyz5MQQLgqUJ_2E_,
  .aXYOWP8LE6wiVNwN {
    font-size: 11px;
    width: 131px;
    height: 26px;
    border-radius: 6px;
    padding: 8px 14px;
  }
  
  .Rv38fSdk5c2MeUO3 .p-accordion-content {
    padding: 5px;
  }
  
  .Su9HbssAiNB2K6pn {
    display: none;
  }
  
  .efrA6tVm0jcxhmAk span::before {
    font-size: 12px;
  }
  
  .ATJvkSeaxKU_JFsx {
    gap: 1px;
  }
}

@media screen and (max-width: 540px) {
  .tQgBQ6Ui33MGby9t {
    max-width: 110px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media screen and (max-width: 450px) {
  .P3c52QVyrMo03tFK {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/MenuItems.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd;iCAC+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB,cAAc;AACd,eAAe;AACf,iBAAiB;AACjB,IAAI;;AAEJ;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB;iCAC+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB;iCAC+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ;iCAC+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,sGAAsG;EACxG;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,SAAS;IACT,MAAM;EACR;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".pageWrapper {\r\n  max-width: 1315px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.dropdown {\r\n  width: 300px;\r\n  padding: 12px 10px;\r\n  border-radius: 16px;\r\n}\r\n\r\n.groupActions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: start;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.expandToggleWrapper {\r\n  display: flex;\r\n  margin-top: 28px;\r\n  gap: 12px;\r\n}\r\n\r\n.expandButton,\r\n.collapseButton {\r\n  margin-bottom: 5px;\r\n  padding: 8px 14px;\r\n  font-size: 18px;\r\n  font-weight: 300;\r\n  border-radius: 6px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background-color: #fff;\r\n  color: #7b7b7b;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.expandButton:hover,\r\n.collapseButton:hover {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.left {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.toggleWrapper {\r\n  margin-right: 10px;\r\n}\r\n\r\n.createGroupBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.createGroupBtn i {\r\n  font-size: 16px;\r\n  background-color: #4d87be;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-right: 12px;\r\n}\r\n\r\n.createGroupBtn:hover i {\r\n  background-color: #20336c;\r\n}\r\n\r\n.createGroupBtn:hover .createBtnText {\r\n  text-decoration: underline;\r\n}\r\n\r\n.createGroupBtn .createBtnText {\r\n  text-decoration: none;\r\n}\r\n\r\n.accordion {\r\n  border-radius: 16px;\r\n  background-color: #fff;\r\n  padding: 10px;\r\n}\r\n\r\n.accordion :global(.p-accordion) {\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.accordion :global(.p-accordion .p-accordion-tab) {\r\n  border: none;\r\n}\r\n\r\n.accordion :global(.p-accordion-header-link) {\r\n  background-color: #fff;\r\n  border: none;\r\n}\r\n\r\n.accordion :global(.p-accordion-content) {\r\n  background-color: #fff;\r\n  border: none;\r\n}\r\n\r\n.accordionHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.accordionHeader span {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.listWrapper :global(.p-orderlist-controls) {\r\n  display: none;\r\n}\r\n\r\n/*.orderListItem {*/\r\n/*\tmargin: 0;*/\r\n/*\tpadding: 0;*/\r\n/*\theight: 80px;*/\r\n/*}*/\r\n\r\n.dropDownWrapper {\r\n  margin: 0 30px 52px;\r\n  width: calc(100% - 60px);\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown) {\r\n  width: 100%;\r\n  height: 66px;\r\n  border-radius: 24px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label) {\r\n  display: block;\r\n  padding: 17px 32px 24px;\r\n  font-size: 21px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.dropDownPanel {\r\n  border-radius: 24px;\r\n  border: 1px solid #a4a4a4;\r\n  overflow: hidden;\r\n  padding: 16px 34px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n  max-height: 400px !important;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 88px;\r\n  border-radius: 6px;\r\n  margin: 4px 0px;\r\n  padding: 4px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight) {\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-header) {\r\n  background-color: #f2e1bc;\r\n  border-radius: 0 0 0 0;\r\n  border: none;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-list) {\r\n  border-radius: 0 0 0 0;\r\n  border: none;\r\n  background-color: #faf9f8;\r\n}\r\n\r\n.orderListItem :global(.p-orderlist-item:hover) {\r\n  background-color: #f5f4f3;\r\n}\r\n\r\n.stationOptionItem {\r\n  height: 100%;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n}\r\n\r\n.header,\r\n.stationOptionItem {\r\n  display: flex;\r\n}\r\n\r\n.header > div,\r\n.stationOptionItem > div {\r\n  width: 25%;\r\n  align-self: center;\r\n}\r\n\r\n.header > .column1,\r\n.stationOptionItem > .column1 {\r\n  width: 95px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.imageEdit {\r\n  position: absolute;\r\n  color: #fff;\r\n  width: 67px;\r\n  height: 67px;\r\n  display: none;\r\n  border-radius: 6px;\r\n}\r\n\r\n.imageEdit:hover {\r\n  background: rgba(0, 0, 0, 0.35);\r\n  backdrop-filter: blur(0.893727px);\r\n  display: flex;\r\n}\r\n\r\n.imageEdit:hover::before {\r\n  display: flex;\r\n}\r\n\r\n.imageEdit::before {\r\n  top: 37%;\r\n  left: 37%;\r\n  font-size: 18px;\r\n  position: absolute;\r\n  display: none;\r\n}\r\n\r\n.optionImage {\r\n  width: 67px;\r\n  height: 67px;\r\n  overflow: hidden;\r\n  border-radius: 6px;\r\n}\r\n\r\n.optionNote {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.expandButton {\r\n  margin-right: 5px;\r\n}\r\n\r\n.expandButton,\r\n.collapseButton {\r\n  margin-bottom: 5px;\r\n  padding: 8px 14px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  border: 1px solid rgb(222, 226, 230);\r\n  border-radius: 3px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.isMultipleSelectButton {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.groupActionsWrapper {\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\n.activeBtn {\r\n  width: 114px;\r\n  height: 67px;\r\n}\r\n\r\n.activeBtn:hover {\r\n  background-color: #e1e7ed;\r\n  border-radius: 6px;\r\n}\r\n\r\n.orderBtn {\r\n  color: #818b93;\r\n}\r\n\r\n.orderBtn:hover {\r\n  background-color: #dfdfdf;\r\n}\r\n\r\n.addOptionBtn {\r\n  color: #c88900;\r\n}\r\n\r\n.addOptionBtn:hover {\r\n  background-color: #f2e1bc;\r\n  color: #9a6a00;\r\n}\r\n\r\n.editGroupBtn {\r\n  color: #4d87be;\r\n}\r\n\r\n.editGroupBtn:hover {\r\n  background-color: #e1e7ed;\r\n  color: #20336c;\r\n}\r\n\r\n.deleteGroupBtn {\r\n  color: #dd0000;\r\n}\r\n\r\n.deleteGroupBtn:hover {\r\n  background-color: #ffcaca;\r\n  color: #721010;\r\n}\r\n\r\n.optionActionsWrapper {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.editOptionBtn {\r\n  color: #4d87be;\r\n  width: 75px;\r\n  height: 67px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.editOptionBtn:hover {\r\n  background-color: #e1e7ed;\r\n  color: #20336c;\r\n}\r\n\r\n.deleteOptionBtn {\r\n  color: #dd0000;\r\n  width: 75px;\r\n  height: 67px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.deleteOptionBtn:hover {\r\n  background-color: #ffcaca;\r\n  color: #721010;\r\n}\r\n\r\n.groupModal {\r\n  width: 674px !important;\r\n  height: fit-content;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.groupModal :global(.p-dialog) {\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.groupModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 16px !important;\r\n  border-bottom-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 16px !important;\r\n  border-top-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal {\r\n  width: 541px !important;\r\n  height: 354px !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog-content) {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.groupDeleteModal .text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.saveBtn {\r\n  width: 100%;\r\n  background-color: #56be4d;\r\n  border-radius: 16px;\r\n  padding: 18px 0px;\r\n  color: #ffffff;\r\n  border: none;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.saveBtn:hover {\r\n  background-color: #185625;\r\n}\r\n\r\n.selectButton {\r\n  background-color: #e1e7ed;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.selectButton :global(.p-button) {\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 20px;\r\n  padding: 15px 0px;\r\n}\r\n\r\n.selectButton :global(.p-highlight) {\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n}\r\n\r\n.input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  background-color: #ffffff;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.numberInput input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  background-color: #ffffff;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.textarea {\r\n  background-color: #ffffff;\r\n  border-radius: 16px;\r\n  height: 91px;\r\n  padding: 14px 20px;\r\n  font-size: 18px;\r\n  resize: none;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.deleteDialogBtn {\r\n  width: 100%;\r\n  background-color: #dd0000;\r\n  border-radius: 16px;\r\n  padding: 18px 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n  background-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n  width: 100%;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px;\r\n  padding: 10px 20px;\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n  color: #305375;\r\n}\r\n\r\n.imageModal {\r\n  width: 604px;\r\n  height: 475px;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog-content) {\r\n  max-height: 300px !important;\r\n  padding: 0 !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModal :global(.p-dialog) {\r\n  border-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 16px !important;\r\n  border-top-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModal :global(.p-dialog-footer) {\r\n  padding: 1.5rem !important;\r\n  border-bottom-right-radius: 16px !important;\r\n  border-bottom-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.cardWrapper {\r\n  display: inline-block;\r\n}\r\n\r\n.preview {\r\n  padding: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.optionCard {\r\n  width: 250px;\r\n  height: 250px;\r\n  border-radius: 25px;\r\n  overflow: hidden;\r\n}\r\n\r\n.optionCard .image {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.uploadBtn {\r\n  width: 100%;\r\n}\r\n\r\n.uploadBtn > span {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n  padding: 14px 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.uploadBtn > span:hover {\r\n  background-color: #20336c;\r\n}\r\n\r\n.uploadBtn > span > span {\r\n  width: fit-content;\r\n  flex-grow: 0;\r\n}\r\n\r\n.groupModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.groupModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupDeleteModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.groupModal :global(.field) label {\r\n  font-size: 20px !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.cardList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.cardItem {\r\n  background: #ffffff;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n  min-height: 63px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.cardImage {\r\n  background-size: cover;\r\n  min-width: 56px !important;\r\n  min-height: 56px !important;\r\n  background-color: gray;\r\n  color: #ffffff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.cardInfo {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.cardInfo .info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 8px;\r\n}\r\n\r\n.name {\r\n  font-weight: 500;\r\n  color: #303030;\r\n  font-size: 14px;\r\n}\r\n\r\n.subfield {\r\n  color: #888888;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.cardEditBtn {\r\n  color: #1976d2;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.cardDeleteBtn {\r\n  color: #d32f2f;\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n}\r\n\r\n.cardEditBtn i::before,\r\n.cardDeleteBtn i::before {\r\n  font-size: 16px;\r\n}\r\n\r\n.createBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n\r\n.createBtn i {\r\n  margin-left: 0;\r\n  width: 100%;\r\n  font-size: 14px;\r\n  background-color: #f2e1bc;\r\n  padding: 6px;\r\n  border-radius: 8px;\r\n}\r\n\r\n@media screen and (min-width: 768px) and (max-width: 1024px) {\r\n  .stationOptionItem {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(2) {\r\n    width: 180px !important;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(3) {\r\n    width: 100px !important;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(4) {\r\n    width: 80px !important;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(5) {\r\n    width: 200px !important;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(6) {\r\n    width: 80px !important;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(7) {\r\n    width: 120px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(2) {\r\n    width: 180px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(3) {\r\n    width: 100px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(4) {\r\n    width: 80px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(5) {\r\n    width: 200px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(6) {\r\n    width: 80px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(7) {\r\n    width: 120px !important;\r\n  }\r\n  \r\n  .optionImage {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n  \r\n  .editOptionBtn,\r\n  .deleteOptionBtn {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n  \r\n  .activeBtn {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n  \r\n  .optionActionsWrapper {\r\n    gap: 4px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) and (max-width: 900px) {\r\n  .stationOptionItem > div:nth-child(2) {\r\n    width: 150px !important;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(3) {\r\n    width: 80px !important;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(4) {\r\n    width: 70px !important;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(5) {\r\n    width: 160px !important;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(6) {\r\n    width: 70px !important;\r\n  }\r\n  \r\n  .stationOptionItem > div:nth-child(7) {\r\n    width: 100px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(2) {\r\n    width: 150px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(3) {\r\n    width: 80px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(4) {\r\n    width: 70px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(5) {\r\n    width: 160px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(6) {\r\n    width: 70px !important;\r\n  }\r\n  \r\n  .header > div:nth-child(7) {\r\n    width: 100px !important;\r\n  }\r\n  \r\n  .optionImage {\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n  \r\n  .editOptionBtn,\r\n  .deleteOptionBtn {\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n  \r\n  .activeBtn {\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n  \r\n  .optionActionsWrapper {\r\n    gap: 2px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .groupDeleteModal,\r\n  .groupModal {\r\n    width: 350px !important;\r\n  }\r\n  \r\n  .groupModal :global(.field) label {\r\n    font-size: 14px !important;\r\n  }\r\n  \r\n  .imageModal :global(.p-dialog-title),\r\n  .groupDeleteModal :global(.p-dialog-title),\r\n  .groupModal :global(.p-dialog-title) {\r\n    font-size: 20px !important;\r\n    font-weight: 700 !important;\r\n  }\r\n  \r\n  .groupDeleteModal .text {\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .input {\r\n    font-size: 14px;\r\n    padding: 14px 20px;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n  }\r\n  \r\n  .saveBtn {\r\n    padding: 14px 0;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .deleteDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 14px 16px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .cancelDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .selectButton {\r\n    background-color: #e1e7ed;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .selectButton :global(.p-button) {\r\n    background-color: transparent;\r\n    border: none;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    padding: 15px 0;\r\n  }\r\n  \r\n  .selectButton :global(.p-highlight) {\r\n    background-color: #4d87be;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .imageModal {\r\n    width: 350px;\r\n  }\r\n  \r\n  .imageModal p {\r\n    font-size: 14px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .uploadBtn > span {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 764px) {\r\n  .accordionHeader span {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 660px) {\r\n  .accordionHeader span {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n  .pageHeader {\r\n    flex-direction: column;\r\n    justify-content: start;\r\n    align-items: start;\r\n    width: 100%;\r\n  }\r\n  \r\n  .pageHeader h2 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n  \r\n  .dropdown {\r\n    width: 100%;\r\n    font-size: 14px !important;\r\n    border-radius: 16px;\r\n    padding: 4px 6px;\r\n    height: 44px;\r\n  }\r\n  \r\n  .dropdown::placeholder {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .groupActions {\r\n    flex-direction: row-reverse;\r\n    margin-top: 16px;\r\n    align-items: start;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .expandToggleWrapper {\r\n    margin: 0;\r\n    gap: 0;\r\n  }\r\n  \r\n  .createGroupBtn {\r\n    padding: 0;\r\n  }\r\n  \r\n  .createGroupBtn span {\r\n    display: none;\r\n  }\r\n  \r\n  .createGroupBtn i {\r\n    font-size: 14px;\r\n    width: 63px;\r\n    height: 26px;\r\n    border-radius: 6px;\r\n    margin: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .expandButton,\r\n  .collapseButton {\r\n    font-size: 11px;\r\n    width: 131px;\r\n    height: 26px;\r\n    border-radius: 6px;\r\n    padding: 8px 14px;\r\n  }\r\n  \r\n  .accordion :global(.p-accordion-content) {\r\n    padding: 5px;\r\n  }\r\n  \r\n  .addOptionBtn {\r\n    display: none;\r\n  }\r\n  \r\n  .orderBtn span::before {\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .actions {\r\n    gap: 1px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 540px) {\r\n  .subfield {\r\n    max-width: 110px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n}\r\n@media screen and (max-width: 450px) {\r\n  .name {\r\n    font-size: 12px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `EqBehoiL60usTp4g`;
export var pageHeader = `eDzJmS83yUM7I_b4`;
export var dropdown = `t02RuAJHAtMPsWbz`;
export var groupActions = `ScMM79oFMI47oNfe`;
export var expandToggleWrapper = `NeprssEXbLAhxVc_`;
export var expandButton = `Kyz5MQQLgqUJ_2E_`;
export var collapseButton = `aXYOWP8LE6wiVNwN`;
export var left = `bUqCUqK_sCQOYVgF`;
export var toggleWrapper = `YQZXWKkYsbUbr2ME`;
export var createGroupBtn = `Bgn0L4AEMEkf0RyZ`;
export var createBtnText = `pBx1O2u1g83OmIl7`;
export var accordion = `Rv38fSdk5c2MeUO3`;
export var accordionHeader = `oRsJzZQ1KMkQMA3Q`;
export var listWrapper = `ycu1LDWik4VDuu7Z`;
export var dropDownWrapper = `g2ed92cNMFUNe4rT`;
export var dropDownPanel = `JrwjgJX2c8MgsJ6H`;
export var orderListItem = `z9mX0yBXQVwuqqYg`;
export var stationOptionItem = `IZIJKEQ5ooE38He2`;
export var header = `QAkUSnOFbe4gGLJY`;
export var column1 = `IpM8k09LUIObbxHz`;
export var imageEdit = `DI7llyzTVHApKbHu`;
export var optionImage = `K4bg2eI5Ps_nb417`;
export var optionNote = `NZj70HNlZBozZQCG`;
export var isMultipleSelectButton = `Nx9os3kIkdo7Kjbe`;
export var groupActionsWrapper = `BU2Dd3sNzkrxit8n`;
export var activeBtn = `LQ9jxmHt4kE5IbFW`;
export var orderBtn = `efrA6tVm0jcxhmAk`;
export var addOptionBtn = `Su9HbssAiNB2K6pn`;
export var editGroupBtn = `T5IW7Dnm9IphZnJt`;
export var deleteGroupBtn = `l4e1U4fBAY2OtonJ`;
export var optionActionsWrapper = `kh_Uh3ZrksE6sDaz`;
export var editOptionBtn = `jwXN6S86nVghNM9L`;
export var deleteOptionBtn = `oZCnxg5ygQnaJsZk`;
export var groupModal = `pG1fG2WihMsrGsfh`;
export var groupDeleteModal = `By_14zkV4XUVNJKa`;
export var text = `RaqWt5qIR14DkLs6`;
export var saveBtn = `QSHyt7sOmMwSZ6Kf`;
export var selectButton = `d8TTigY5xWktckql`;
export var input = `NBV7bgeoBgmliiyv`;
export var numberInput = `k2GbHgRW4rZk_JIs`;
export var textarea = `aqtEWWvRQtoudWLx`;
export var deleteDialogBtn = `lqqhiUYbbL0eaHSe`;
export var cancelDialogBtn = `RJyi_a8SMoa_MB_w`;
export var imageModal = `SNjLIZnuEILBidDk`;
export var cardWrapper = `v9cdw2UvuTcYOa0t`;
export var preview = `SQBO1xc2tO8EWgJF`;
export var optionCard = `GkeIc9cHaMrjJczz`;
export var image = `CmxWy2ztikMeuGQt`;
export var uploadBtn = `SHjY2wLeVtMfzeAq`;
export var cardList = `e7fzFJef582wNzou`;
export var cardItem = `NFn9akhDRXA15dAI`;
export var cardImage = `AFJLDsDEJU4t4ONL`;
export var cardInfo = `N0kaviNcQkcaVHnz`;
export var info = `mVytRCEAikVQWGzO`;
export var name = `P3c52QVyrMo03tFK`;
export var subfield = `tQgBQ6Ui33MGby9t`;
export var actions = `ATJvkSeaxKU_JFsx`;
export var cardEditBtn = `meyIPXyliMA2xdCy`;
export var cardDeleteBtn = `iJZRbXbk4qAMbMam`;
export var createBtn = `pCT9a4sDYRAjhpln`;
export default ___CSS_LOADER_EXPORT___;
